import { useContext } from "react"
import AnsweredFormOverviewContext from "../AnsweredFormOverviewContext"

const useAnsweredFormOverviewContext = () => {
  const providedValue = useContext(AnsweredFormOverviewContext)

  return { ...providedValue }
}

export default useAnsweredFormOverviewContext
